import fetchClient from './fetchClient';
import { errorHandler } from './utils';

const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export interface CustomExportField {
    key: string;
    label: string;
}

export interface CustomExportEntity {
    entity: string;
    label: string;
    fields: CustomExportField[];
}

export const getCustomExportFields = async (): Promise<CustomExportEntity[] | null> => {
    try {
        const res = await fetchClient.get('/export/custom/fields', config());
        return res.data;
    } catch (err: any) {
        errorHandler(err);
        return null;
    }
};

export const downloadCustomExport = async (entity: string, fields: string[]): Promise<boolean> => {
    try {
        const res = await fetchClient.post(
            '/export/custom/csv',
            { entity, fields },
            { ...config(), responseType: 'blob' }
        );

        if (!res || !res.data) return false;

        const cd = (res.headers?.['content-disposition'] || '') as string;
        const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd || '');
        const filename = decodeURIComponent(match?.[1] || match?.[2] || `export-personnalise-${entity}.csv`);

        const url = window.URL.createObjectURL(res.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        return true;
    } catch (err: any) {
        try {
            const blob = err?.response?.data as Blob | undefined;
            const text = blob ? await blob.text() : '';
            if (text) {
                const json = JSON.parse(text);
                errorHandler({ response: { data: { error: json?.error || 'Export impossible' } } });
            } else {
                errorHandler(err);
            }
        } catch {
            errorHandler(err);
        }
        return false;
    }
};
